import React, {useEffect} from "react";


import { ReactSVG } from "react-svg";


import { Col, Row } from "react-bootstrap";

import iconArrowDown from "@Icons/SVG/icon-arrow_down-s-grey.svg";


import "./index.scss";


export type FormDropdownOptionType = {
    optionID: number;
    optionValue: string;
};


type FormDropdownComponentProps = {
    fieldOptions: FormDropdownOptionType[];
    optionChoiceHandler: (optionID: number) => void;
    selectedOptionID?: number;
    fieldLabelText?: string;
    fieldRequiredStatus?: boolean;
    fieldDisabledStatus?: boolean;
};


export const FormDropdownComponent:React.FC<FormDropdownComponentProps> = ({
    fieldOptions = [], selectedOptionID = 0, optionChoiceHandler,
    fieldLabelText,
    fieldRequiredStatus, fieldDisabledStatus
}) => {


    const [dropdownOpenStatus, setDropdownOpenStatus] = React.useState(false);

    useEffect(() => {
        return () => {
            setDropdownOpenStatus(false);
        }
    }, []);

    const dropdownOpenStatusHandler = () => {
        if (fieldDisabledStatus) {
            return;
        }
        setDropdownOpenStatus(!dropdownOpenStatus);
    };

    const dropdownOptionChoiceHandler = (optionId: number) => {
        optionChoiceHandler(optionId);
        setDropdownOpenStatus(false);
    };


    if (fieldOptions.length < 1) {
        return null;
    }


    const FieldOptionList = fieldOptions.map((option) => {
        if (option.optionID === selectedOptionID) {
            return null;
        }
        return (
            <Col key={option.optionID} xs={12} onClick={() => dropdownOptionChoiceHandler(option.optionID)} className={'form-dropdown-component__dropdown-field__options-list__option'}>
                <span>{option.optionValue}</span>
            </Col>
        );
    });

    const selectedOption = fieldOptions.filter((option) => option.optionID === selectedOptionID)[0];


    return (
        <Col xs={12} className={'form-dropdown-component'}>
            <Row className={'form-dropdown-component__content'}>

                {fieldLabelText &&
                <Col xs={12} className={'form-dropdown-component__dropdown-label'}>
                    <span className={'field-label-text'}>{fieldLabelText}</span>
                    {fieldRequiredStatus &&
                    <span className={'field-required-status'}>*</span>
                    }
                </Col>
                }

                <Col xs={12} className={'form-dropdown-component__dropdown-field' + (fieldDisabledStatus ? ' field-disabled' : '')}>
                    <Row className={'form-dropdown-component__dropdown-field__content'}>

                        <Col xs={12} onClick={dropdownOpenStatusHandler} className={'form-dropdown-component__dropdown-field__chosen-option' + (selectedOptionID !== 0 ? ' option-selected' : '') + (fieldDisabledStatus ? ' field-disabled' : '')}>
                            <span className={'dropdown-option-value'}>{selectedOption?.optionValue}</span>
                            <ReactSVG src={iconArrowDown} wrapper={'span'} className={'dropdown-arrow-icon'} />
                        </Col>

                        {dropdownOpenStatus &&
                        <Col xs={12} className={'form-dropdown-component__dropdown-field__options-list'}>
                            <Row className={'form-dropdown-component__dropdown-field__options-list__content'}>
                                {FieldOptionList}
                            </Row>
                        </Col>
                        }

                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default FormDropdownComponent;
